export default function isUserActive(user) {
  return user.num_activities > 0;
}
